import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SearchStrategyService } from '@services/search-strategy.service';
import { FilterService } from '@services/filter.service';
import { TreeNode } from 'primeng/api';
import { StudySearchStrategy } from '@models/searchStrategy.model';
import { LegalFormCriteria } from './filter-legal-form.model';
import { FilterTypes } from '@models/filterEnums.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FilterUtilService } from '../shared/filter-util.service';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-filter-legal-form',
  templateUrl: './filter-legal-form.component.html',
  styleUrls: ['./filter-legal-form.component.css'],
  providers: [SearchStrategyService],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FilterLegalFormComponent implements OnInit, OnDestroy {
  @Input() filter: any;
  @Input() legalForms: TreeNode[] = [];
  @Input() submitClicked: boolean;
  @Input() readOnly = false;

  formDirty = false;
  searchStrategy: StudySearchStrategy;

  private destroy$ = new Subject();

  constructor(
    private searchStrategyService: SearchStrategyService,
    private filterService: FilterService,
    private filterUtilService: FilterUtilService
  ) {}

  ngOnInit() {
    this.loadInitialData();
  }

  initializeForm() {
    if ((<LegalFormCriteria>this.filter).legalFormSelection) {
      this.filter.legalFormSelection = this.flattenTree(this.legalForms).filter((selection) =>
        this.findNodeRecursive(selection.data, (<LegalFormCriteria>this.filter).legalFormSelection)
      );
    }
  }

  async loadInitialData() {
    this.filterUtilService.spinnerRS.next(true);
    this.searchStrategy = this.searchStrategyService.studySearchStrategy;
    this.filterService
      .getLegalForms$(this.readOnly)
      .pipe(takeUntil(this.destroy$))
      .subscribe((_legalForms) => {
        this.legalForms = _legalForms;
        this.initializeForm();
        this.filterUtilService.spinnerRS.next(false);
      });
  }

  private flattenTree(nodes: TreeNode[]): TreeNode[] {
    return this.filterUtilService.flattenTree(nodes);
  }

  public sortSelection(selection: TreeNode[]): void {
    return this.filterUtilService.sortSelection(selection);
  }

  private findNodeRecursive(id: FilterTypes, nodes: TreeNode[]) {
    return this.filterUtilService.findNodeRecursive(id, nodes);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
